import * as ambassadorWixPortfolioPortfolioAppV1PortfolioSettings from './portfolio-portfolio-app-v1-portfolio-settings-portfolio-settings.http.js';
import * as ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsTypes from './portfolio-portfolio-app-v1-portfolio-settings-portfolio-settings.types.js';
import * as ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsUniversalTypes from './portfolio-portfolio-app-v1-portfolio-settings-portfolio-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createPortfolioSettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsUniversalTypes.CreatePortfolioSettingsRequest,
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsTypes.CreatePortfolioSettingsRequest,
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsUniversalTypes.CreatePortfolioSettingsResponse,
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsTypes.CreatePortfolioSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioPortfolioAppV1PortfolioSettings.createPortfolioSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/portfolio/settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPortfolioSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsUniversalTypes.GetPortfolioSettingsRequest,
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsTypes.GetPortfolioSettingsRequest,
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsUniversalTypes.GetPortfolioSettingsResponse,
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsTypes.GetPortfolioSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioPortfolioAppV1PortfolioSettings.getPortfolioSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/portfolio/settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePortfolioSettings(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsUniversalTypes.UpdatePortfolioSettingsRequest,
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsTypes.UpdatePortfolioSettingsRequest,
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsUniversalTypes.UpdatePortfolioSettingsResponse,
  ambassadorWixPortfolioPortfolioAppV1PortfolioSettingsTypes.UpdatePortfolioSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioPortfolioAppV1PortfolioSettings.updatePortfolioSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/api/v1/portfolio/settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
